import supabase from './supabaseUtils';

export async function recordLogin(userId) {
  try {
    await supabase.from('user_logins').insert({ user_id: userId });
  } catch (err) {
    console.error('[loginTracker]', err);
  }
}
